const root=()=>window.Shopify?.routes?.root||'/';
class FibriyaMobileMenu extends HTMLElement{
 connectedCallback(){
  // Reconnection can interrupt a section fetch. Never inherit its busy state.
  this.cancelLoad();this.controller?.abort();this.contentObserver?.disconnect();
  this.controller=new AbortController();const signal=this.controller.signal;
  this.drawer=this.closest('header-drawer');this.main=this.drawer?.querySelector(':scope > details');
  this.categories=this.querySelector('.fm-categories');this.products=this.querySelector('.fm-products');
  this.contentObserver=new MutationObserver(()=>this.reconcile());
  this.contentObserver.observe(this,{childList:true,subtree:true});
  this.categories.addEventListener('toggle',()=>{
   if(this.categories.open){this.style.setProperty('--fm-products-height',this.productHeight+'px');this.classList.add('fm-expanded');}
   else{this.classList.remove('fm-expanded');this.scrollTop=0;}
   this.categories.querySelector('summary').setAttribute('aria-expanded',String(this.categories.open));
  },{signal});
  this.categories.querySelector('summary').addEventListener('click',()=>{if(!this.categories.open)this.productHeight=this.products.getBoundingClientRect().height},{signal});
  this.querySelector('[data-fm-search]').addEventListener('click',()=>{
   this.drawer.close();
   const search=[...document.querySelectorAll('header-component .search-modal__button')].find(button=>button.getClientRects().length);
   if(search)search.click();else location.href=root()+'search';
  },{signal});
  this.main?.addEventListener('toggle',()=>{if(this.main.open){this.load();}else{this.categories.open=false;this.scrollTop=0;}},{signal});
  this.resize=new ResizeObserver(()=>{if(!this.categories.open)this.productHeight=this.products.getBoundingClientRect().height});this.resize.observe(this.products);
  window.addEventListener('pageshow',()=>{if(this.main?.open)this.load()},{signal});
  if(this.main?.open)this.load();
 }
 disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();this.contentObserver?.disconnect();this.cancelLoad()}
 reconcile(){
  const products=this.querySelector('.fm-products');if(!products)return;
  if(products!==this.products){this.cancelLoad();this.products=products;this.resize?.disconnect();this.resize?.observe(products);}
  if(this.main?.open&&!this.loading&&!products.querySelector('.fm-product,button'))this.load();
 }
 cancelLoad(){
  this.loadVersion=(this.loadVersion||0)+1;this.request?.abort();
  clearTimeout(this.loadTimeout);this.loading=false;
  this.products?.setAttribute('aria-busy','false');
 }
 async load(){
  if(this.querySelector('.fm-products')!==this.products){this.reconcile();return;}
  if(this.loading)return;
  if(this.products.querySelector('.fm-product')&&Date.now()-(this.loadedAt||0)<30000)return;
  this.loading=true;this.products.setAttribute('aria-busy','true');
  // Replace cards atomically: refreshing must not flash an empty product rail.
  const status=document.createElement('p');status.className='fm-load-status';status.setAttribute('role','status');status.textContent=this.dataset.loading;
  if(!this.products.querySelector('.fm-product'))this.products.replaceChildren(status);
  const version=this.loadVersion=(this.loadVersion||0)+1;
  const request=this.request=new AbortController();let timedOut=false;
  const timeout=this.loadTimeout=setTimeout(()=>{timedOut=true;request.abort()},15000);
  try{
   let next=root()+'collections/all';const visited=new Set(),ids=new Set(),cards=[];
   while(next&&cards.length<8){
    const url=new URL(next,location.origin);if(url.origin!==location.origin||visited.has(url.pathname+url.search))throw Error('Invalid bestseller page');visited.add(url.pathname+url.search);
    url.searchParams.set('sort_by','best-selling');url.searchParams.set('section_id','fibriya-menu-bestsellers');
    const response=await fetch(url,{credentials:'same-origin',signal:request.signal});if(!response.ok)throw Error('Bestsellers unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');const page=doc.querySelector('[data-fm-bestseller-page]');
    if(!page||page.dataset.sort!=='best-selling'||page.dataset.collection!=='all')throw Error('Invalid bestseller order');
    for(const card of page.querySelectorAll('.fm-product[data-available="true"]')){if(!ids.has(card.dataset.productId)){ids.add(card.dataset.productId);cards.push(document.importNode(card,true));}if(cards.length===8)break}
    next=page.dataset.next;
   }
   if(!cards.length)throw Error('No available bestseller products');
   for(const card of cards)for(const button of card.querySelectorAll('.quick-add__button')){
    const label=button.querySelector('.add-to-cart-text__content')?.textContent?.trim();if(label)button.setAttribute('aria-label',label+' – '+card.querySelector('.fm-product-title').textContent.trim());
   }
   if(version!==this.loadVersion||!this.isConnected)return;
   this.products.replaceChildren(...cards);this.products.scrollLeft=0;this.loadedAt=Date.now();
  }catch(error){
   if(version!==this.loadVersion||!this.isConnected)return;
   if(error.name==='AbortError'&&!timedOut)return;
   status.textContent='';const retry=document.createElement('button');retry.type='button';retry.textContent=this.dataset.retry;retry.onclick=()=>this.load();status.append(retry);
   this.products.replaceChildren(status);
   console.warn('Mobile menu bestsellers could not be loaded',timedOut?'timeout':error.name);
  }finally{clearTimeout(timeout);if(version===this.loadVersion){this.loading=false;this.products.setAttribute('aria-busy','false')}}
 }
}
if(!customElements.get('fibriya-mobile-menu'))customElements.define('fibriya-mobile-menu',FibriyaMobileMenu);

const preferenceKey='fibriya-menu-languages-v1';
const preferences=()=>{try{const value=JSON.parse(localStorage.getItem(preferenceKey)||'{}');return value&&typeof value==='object'&&!Array.isArray(value)?value:{}}catch{return {}}};
class FibriyaMenuLocalization extends HTMLElement{
 connectedCallback(){
  queueMicrotask(()=>{if(this.isConnected)this.initialize()});
 }
 initialize(){
  this.controller?.abort();this.controller=new AbortController();const {signal}=this.controller;
  const details=this.querySelector('details'),summary=details.querySelector('summary');
  const languageForm=this.querySelector('.fm-locale-language'),select=languageForm.querySelector('select');
  this.classList.add('fm-locale-ready');
  details.addEventListener('toggle',()=>summary.setAttribute('aria-expanded',String(details.open)),{signal});
  document.addEventListener('pointerdown',event=>{if(details.open&&!this.contains(event.target))details.open=false},{signal});
  this.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){event.preventDefault();event.stopPropagation();details.open=false;summary.focus()}},{signal});
  this.closest('header-drawer')?.querySelector(':scope > details')?.addEventListener('toggle',event=>{if(!event.target.open)details.open=false},{signal});
  select.addEventListener('change',()=>languageForm.requestSubmit(),{signal});
  languageForm.addEventListener('submit',()=>{
   try{const saved=preferences();saved[this.dataset.country]=select.value;localStorage.setItem(preferenceKey,JSON.stringify(saved))}catch{}
  },{signal});
  // A direct visit to the market root otherwise resets to its default language.
  // Restore only an explicitly selected, still-published language. Explicit
  // language paths and shared product/article links keep their requested locale.
  try{
   const saved=preferences()[this.dataset.country],guard='fm-locale-restore-'+this.dataset.country;
   const published=[...select.options].some(option=>option.value===saved);
   if(saved===this.dataset.language)sessionStorage.removeItem(guard);
   if(location.pathname==='/'&&saved&&saved!==this.dataset.language&&published&&Date.now()-Number(sessionStorage.getItem(guard)||0)>30000){
    sessionStorage.setItem(guard,String(Date.now()));select.value=saved;languageForm.requestSubmit();
   }
  }catch{}
  // Shopify's localization form persists the language and changes country/currency
  // together. Country buttons explicitly set the target market's default language.
 }
 disconnectedCallback(){this.controller?.abort()}
}
if(!customElements.get('fibriya-menu-localization'))customElements.define('fibriya-menu-localization',FibriyaMenuLocalization);
